<template>
  <div class="rank-com">
    <TxBg src="oldclassic_m_rank_beijing-liebiao" class="center">
      <!-- <div class="search-empty"></div> -->
      <TxBg src="oldclassic_m_rank_title" class="mt-110" />
      <search
        class="rank-search -mt-40"
        @doSearch="doSearch"
        :redirect="false"
      />

      <div class="fanhui-com">
        <TxBtn src="rank_fanhui" name="返回" @click="goBack(router)" />
      </div>

      <query @op_change="opChange" :is_search="true" />

      <TxBg
        src="oldclassic_m_rank_liebiaodiban"
        class="-mt-24 pt-130 overflow-x px-44"
      >
        <div class="table-type">查询结果</div>
        <div class="table-tips">< 左右滑动查看多信息！ ></div>
        <div class="overflow-x">
          <tx-table
            :columns="columns"
            :data="ranks"
            class="rank-table"
          ></tx-table>
        </div>
      </TxBg>

      <TxPagination
        @pageChange="pageChange"
        v-model:page="page"
        :total="total"
        :size="size"
      />
    </TxBg>

    <Link />
  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
const { is_mobile, schools, sectors } = inject('GlobalStore');
import { get_search } from '@utils/api';
import query from './components/rank/query.vue';
import search from './components/search.vue';
import Link from './components/link.vue';
import { goBack } from '@utils/goBack';
import eventEmitter from '@utils/event';

const router = useRouter();
const route = useRoute();
const ranks = ref([]);

const total = ref(0);
const size = ref(20);
const page = ref(1);

const columns = ref([
  // {
  //   title: '排名',
  //   key: 'rank',
  //   stylehead: 'font-size:20px;color:red;font-weight:bolder;',
  //   stylecolumn: 'font-size:10px;color:blue;',
  // },
  {
    title: '角色',
    key: 'role',
    render: ({ row }) => {
      return h(
        'a',
        {
          class: 'pointer',
          onClick: () => roleClick(row),
        },
        row.role
      );
    },
  },
  // {
  //   title: '大区',
  //   key: 'server',
  //   render: ({ row }) => {
  //     const name = sector_name(row.server);
  //     return h('span', {}, name);
  //   },
  // },
  {
    title: '服务器',
    key: 'server',
    render: ({ row }) => {
      const name = server_name(row.server);
      return h('span', {}, name);
    },
  },
  {
    title: '等级',
    key: 'level',
  },
  {
    title: '门派',
    key: 'school',
    render: ({ row }) => {
      const _shcool_name = shcool_name(row.school);
      return h('span', {}, _shcool_name);
    },
  },
  {
    title: '势力',
    key: 'clan',
    render: ({ row }) => {
      return h(
        'a',
        {
          class: 'pointer',
          onClick: () => clanClick(row),
        },
        row.clan
      );
    },
  },
  {
    title: '人物修为',
    key: 'xiuwei',
  },
  {
    title: '装备评价',
    key: 'equ_xiuwei',
  },
  {
    title: '总修为',
    key: 'total_xiuwei',
  },
  {
    title: '风华值',
    key: 'fenghua',
  },
]);

const params = computed(() => route.query);

const load_rank = (param = {}) => {
  console.log('load_rank', { page: page.value, ...params.value, ...param });
  get_search({ page: page.value, ...params, ...param }).then((res) => {
    console.log('get_search测试', res);
    if (res.code !== 0) {
      eventEmitter.emit('toast', {
        text: res.errorMsg,
        duration: 5,
      });
      return;
    }
    ranks.value = [...res.data.data];
    total.value = res.data.total;
    size.value = res.data.size;
    page.value = res.data.page;
  });
};

onMounted(() => {
  console.log('params', params.value);
  load_rank(params.value);
});

const shcool_name = (shcool_id) => {
  return schools.value[shcool_id];
};

const sector_name = (server) => {
  return sectors.value[server] || '';
};

const server_name = (server) => {
  return sectors.value[server]?.name || server;
};

const roleClick = (record) => {
  router.push({
    path: `/role`,
    query: {
      key: record.key,
    },
  });
};

const clanClick = (record) => {
  console.log('clanClick', record);
};

const pageChange = (page) => {
  load_rank(params.value);
};

const opChange = (filter_op) => {
  const newQuery = { ...route.query, ...filter_op };
  console.log('opChange', filter_op, newQuery);

  router.replace({
    path: `/search`,
    query: newQuery,
  });
};

const doSearch = (name) => {
  const newQuery = { ...route.query, name };
  console.log('opChange newQuery:', newQuery);

  router.replace({
    path: `/search`,
    query: newQuery,
  });

  load_rank({ name });
};

const goto_rank = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.replace({
      path: `/rank`,
    });
  }
};
</script>
